import React, {
    useState
} from 'react';
import {
    Row, Col, Container, CardImg, Card
} from "reactstrap";
import MyModal from '../../helpers/MyModal';

import uplandGreens from '../../../assets/images/Upland 2026 students gathering greens with Miss Jessica.jpg';
import uplandGrandparent from '../../../assets/images/Upland adopted grandparent reading card from students.jpg';
import uplandBridge from '../../../assets/images/Upland conflict bridge.jpg';
import uplandAndres from '../../../assets/images/Upland student journalist - Andres.jpg';
import uplandJournalist from '../../../assets/images/Upland student journalist.jpg';
import uplandGrounds from '../../../assets/images/Upland students on school grounds.jpg';
import uplandHospital from '../../../assets/images/Upland team at hospital.jpg';

const images = [
    {
        src: uplandGrandparent,
        title: "An adopted grandparent reads a card from the students at Brookdale"
    },
    {
        src: uplandGreens,
        title: "Students gather greens with Miss Jessica for the food bank"
    },
    {
        src: uplandAndres,
        title: "Student journalist Andres with his Heroes News reporter badge"
    },
    {
        src: uplandJournalist,
        title: "A young Heroes News reporter shows her press badge"
    },
    {
        src: uplandBridge,
        title: "Students march across the conflict bridge to resolve a dispute"
    },
    {
        src: uplandHospital,
        title: "The team delivers handmade cards and gifts at San Antonio Regional Hospital"
    },
    {
        src: uplandGrounds,
        title: "Young Humanitarians on the school grounds"
    }
];

const UplandSummer2026 = () => {

    const allImages = {
        images
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState({ src: '', title: '' });

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const showModalImage = (imageId, arrayName) => {
        const selectedArray = allImages[arrayName];
        if (selectedArray) {
            toggleModal();
            setCurrentIndex(selectedArray[imageId]);
        }
    };
    return (
        <Container>
            <MyModal currentIndex={currentIndex} isModalOpen={isModalOpen} toggleModal={toggleModal} />
            <Row>
                <Col
                    sm="12"
                    md={{
                        offset: 1,
                        size: 10
                    }}
                >
                    <h1><strong>Upland Summer School 2026 Bred Young Humanitarians</strong></h1>
                </Col>
                <Col
                    sm="12"
                    md={{
                        offset: 1,
                        size: 10
                    }}
                >
                    <p>Experience shapes identity, evidenced by the progress of the fourth and fifth graders who practiced
                        the &ldquo;Habits of Humanitarians&rdquo; during the 2026 Habits of Heroes Summer School in Upland,
                        California. Parents enjoyed witnessing the growth of their children. Relevant projects helped the
                        students integrate the development of character, curiosity, cognition, creativity, and compassion,
                        to address the needs of their human family. Each week, they also offered their mentors or
                        constituents gifts of music, art, writing or math, and habit-of-heart certificates. This summer&rsquo;s
                        initiatives linked local needs to five habit-of-heart themes:</p>
                    <p><strong>Humanitarianism:</strong> During the first week&rsquo;s culminating project, the young
                        Humanitarians honored their adopted grandparents at Brookdale Assisted Living for their lifelong
                        contributions to society. They sang &ldquo;True Heroes,&rdquo; offered gifts, and interviewed each
                        elder.</p>
                    <p><strong>Farsightedness:</strong> The children evaluated the value of planning ahead to ensure food
                        security for the hungry. They toured the nonprofit Root 66, where they collected farm produce,
                        adding it to food boxes they prepared for the local food bank, Inland Valley Hope Partners. They
                        prepared the boxes to each feed a family of four and recorded the servings or measurements
                        accordingly on the boxes.</p>
                    <p><strong>Universal Connectedness:</strong> A wisdom exchange between the students and a summer school
                        in The Gambia compared ways to feed a population. (Asmi Aggarwal went as a foreign exchange student
                        from the US; among other projects, FCL Gambia dried and packaged moringa tea to enhance nutrition,
                        while the Upland students told of their project for the food bank.) The Upland students wrote letters
                        about universal connectedness to their &ldquo;brothers and sisters&rdquo; at FCL Gambia. They also
                        made school kits for distant refugee children, to be distributed during a visit from the nonprofit
                        JustServe. The children honored their guest for creating these connections, by singing the song
                        &ldquo;Harmony.&rdquo;</p>
                    <p><strong>Understanding:</strong> The Upland students studied &ldquo;A Day in the Life of a
                        Journalist,&rdquo; presented by the staff of Inland Valley News. Prior to the visit, each child had
                        conducted interviews at the school in order to submit their own articles to the news organization
                        based on their food-related research. They sang &ldquo;Questions&rdquo; for their guests and
                        distributed in-boxes they had made, to collect news tips. Some students professed a commitment to
                        pursue careers generating community understanding as journalists.</p>
                    <p><strong>Seeking:</strong> The young humanitarians considered the significance of asking questions to
                        cure disease. They wrote to the National Institute of Health to submit new questions about cancer.
                        They created watercolors of healthy cells to hang in the visiting room of an oncology unit. They also
                        decorated pillowcases for patients, delivering their gifts to San Antonio Regional Hospital. They
                        sang &ldquo;I Aspire&rdquo; for the staff.</p>
                    <p>At the end of the summer, the students prepared a &ldquo;Noble Exhibit&rdquo; based on the
                        humanitarian categories of the Nobel prizes. They presented their learning at a mastery ceremony,
                        celebrating the habits of heart they appreciated in their parents and also receiving certificates of
                        mastery for their own most refined habit-of-heart.</p>
                    <p>The successful six-week program resulted from the combined commitment of the sponsoring nonprofit,
                        People for Peace and Prosperity (PFPP), along with the Special Services Department of the Upland
                        Unified School District and the Global Advisory Board of Full-Circle Learning. The children
                        especially benefited from the mentorship of the staff members, Antoinette Wright, Sierra Pohjola,
                        and Soleil Stevenson. Thanks to everyone who contributed!</p>
                </Col>
                <Col
                    sm="12"
                    md={{
                        offset: 1,
                        size: 10
                    }}
                >
                    <h2><strong>Upland Summer 2026 Highlights</strong></h2>
                </Col>
                <Col
                    sm="12"
                    md={{
                        offset: 1,
                        size: 10
                    }}
                    className='muli-colmn-tw'
                >
                    {images.map((image, index) => (
                        <Card
                            className="image-card"
                            key={image.title}
                            onClick={() => showModalImage(index, "images")}
                            style={{ padding: "6px 0px" }}
                        >
                            <CardImg src={image.src} style={{ height: "400px", objectFit: "cover" }} />
                        </Card>
                    ))}
                </Col>
            </Row>
        </Container>
    )
}

export default UplandSummer2026
